import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { ExternalLinkIcon } from '@domain-group/fe-co-icon';
import { MultiResolutionBackgroundDiv } from '@domain-group/fe-co-multi-resolution-image';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import AllhomesListingCard from '@domain-group/fe-co-allhomes-listing-card';
import NewDevelopmentListings from '../new-development-listings/new-development-listings';
import * as styles from './new-development-child-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NewDevelopmentChildDetails = props => ___EmotionJSX(Fragment, null, ___EmotionJSX(Heading, {
  title: "More about this project"
}), ___EmotionJSX("a", {
  css: styles.card,
  href: props.newDevelopmentUrl
}, ___EmotionJSX("div", {
  css: styles.cardHeroAndLogo
}, ___EmotionJSX(MultiResolutionBackgroundDiv, {
  css: styles.cardHero,
  src: props.thumbnail
}), props.logo && ___EmotionJSX("div", {
  css: styles.developer(props.logoBackgroundColour)
}, ___EmotionJSX("img", {
  css: styles.developerLogo,
  src: props.logo,
  alt: ""
}))), ___EmotionJSX("div", {
  css: styles.cardText
}, ___EmotionJSX("h4", {
  css: styles.cardName
}, props.name), ___EmotionJSX("p", {
  css: styles.cardDescription
}, props.summary), ___EmotionJSX("p", {
  css: styles.cardLink
}, "View entire development"))), !isEmpty(props.otherListings) && ___EmotionJSX("div", null, ___EmotionJSX("h4", {
  css: styles.otherListingsHeading
}, "Other properties in this project"), ___EmotionJSX(NewDevelopmentListings, {
  listings: props.otherListings
}), ___EmotionJSX("a", {
  css: styles.cardLink,
  href: props.newDevelopmentUrl
}, "Show all available properties")), props.newDevelopmentWebsite && ___EmotionJSX("a", {
  css: styles.cardLink,
  href: props.newDevelopmentWebsite,
  target: "_blank",
  rel: "noopener noreferrer",
  onClick: props.onChildDevelopmentLinkClick
}, ___EmotionJSX("span", null, "Visit Development Website"), ___EmotionJSX(ExternalLinkIcon, {
  css: styles.cardLinkIcon
})));
NewDevelopmentChildDetails.propTypes = {
  name: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  newDevelopmentUrl: PropTypes.string.isRequired,
  newDevelopmentWebsite: PropTypes.string,
  otherListings: PropTypes.arrayOf(PropTypes.shape(AllhomesListingCard.propTypes)),
  onChildDevelopmentLinkClick: PropTypes.func,
  logo: PropTypes.string,
  logoBackgroundColour: PropTypes.string
};
NewDevelopmentChildDetails.defaultProps = {
  otherListings: [],
  newDevelopmentWebsite: null,
  onChildDevelopmentLinkClick: () => {},
  logo: null,
  logoBackgroundColour: null
};
export default NewDevelopmentChildDetails;